import { useBootContext } from '@/hooks/useBootContext';

/**
 * Resolves whether the signed-in user is a restricted staff member
 * (public.restricted_staff — insider-threat containment,
 * supabase/migrations/20260810130000_restricted_staff_lockdown.sql). A
 * selector over the boot query (useBootContext), which carries
 * app_is_restricted_staff() beside the identity.
 *
 * Fails OPEN: isRestricted is true only on a confirmed `true`. A failed
 * restriction check alone comes back as not restricted (app_boot_context
 * catches it server-side; the fallback path catches it client-side), and a
 * failed boot query resolves isRestricted false / isLoading false, as the
 * old standalone query did after its retry. A restriction check is a
 * narrowing control on top of normal auth, not the primary gate — failing
 * closed here would turn a transient error into an outage for every
 * non-restricted user. RLS stays the real boundary. A failed boot is still
 * fail-CLOSED for the app as a whole: LocationGate never renders the app
 * without a boot result.
 */
export function useRestrictedStaff(): { isRestricted: boolean; isLoading: boolean } {
  const { query, user } = useBootContext();

  return {
    isRestricted: query.data?.isRestricted === true,
    isLoading: !!user && query.isPending,
  };
}
